export const GET_LIST_CITY = "GET_LIST_CITY"
export const GET_LIST_CITY_SUCCESS = "GET_LIST_CITY_SUCCESS"
export const GET_LIST_CITY_FAIL = "GET_LIST_CITY_FAIL"